import { useCallback, useEffect, useState } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import ModulesDashboard from '../../components/Modules/ModulesDashboard';
import ModulesService from '../../services/ModulesService';

const Unit2Navigation = () => {
  const dispatch = useDispatch();
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);

  const [modulesConfig, setModulesConfig] = useState([]);

  const IMAGES_ENDPOINT = login.cloudFront + 'images';

  const WorldMap = `${IMAGES_ENDPOINT}/Images/Worlds/WorldMap_Large_Unit2_1of5.png${login.cookie}`;

  const getModulesConfiguration = useCallback(
    (modules) => {
      const mappedModules = modules
        .filter((module) => module.unit === 2)
        .map((module) => {
          let config = {};

          if (module.name === 'Greet') {
            config = ModulesService.getModuleConfig({
              currentModule: module,
              previousModule: null,
              totalDays: 9,
              bgImage:
                '/Module6Images/Day+Scene+Nav+Template+-+ML+%E2%80%93+2.png',
              destiny: '/greet/navigation',
              title: module.name,
              character: 'Crab',
              welcomeVideo: '2099182b98e73e4ba3fccae66766/480.m3u8',
              login,
            });
            dispatch({ type: 'SET_MODULE6_INITIALSTATE', payload: module });
          }
          if (module.name === 'Answer') {
            config = ModulesService.getModuleConfig({
              currentModule: module,
              previousModule: modules.find((module) => module.name === 'Greet'),
              totalDays: 9,
              bgImage: '/Module7Images/JourneyMap7.png',
              destiny: '/answer/navigation',
              title: module.name,
              character: 'Dog',
              welcomeVideo: '2e43dfcf5fde08eb7fb60d11054f/480.m3u8',
              login,
            });
            dispatch({
              type: 'SET_MODULE7_INITIALSTATE',
              payload: module,
            });
          }
          if (module.name === 'Ask') {
            config = ModulesService.getModuleConfig({
              currentModule: module,
              previousModule: modules.find(
                (module) => module.name === 'Answer'
              ),
              totalDays: 9,
              bgImage:
                '/Module8Images/Module8NavImages/Background_JourneyMap_Unit2_Mod3.png',
              destiny: '/ask/navigation',
              title: module.name,
              character: 'Lizard',
              welcomeVideo: 'c0be4d2000a50ff15d14df2337ef/480.m3u8',
              login,
            });
            dispatch({
              type: 'SET_MODULE8_INITIALSTATE',
              payload: module,
            });
          }
          if (module.name === 'Respond') {
            config = ModulesService.getModuleConfig({
              currentModule: module,
              previousModule: modules.find((module) => module.name === 'Ask'),
              totalDays: 9,
              bgImage:
                '/Module9Images/Day+Scene+Nav+Template+-+ML+%E2%80%93+5.png',
              destiny: '/respond/navigation',
              title: module.name,
              character: 'Monkey',
              welcomeVideo: '48f60499b47b9e443907c215f45a/480.m3u8',
              login,
            });
            dispatch({
              type: 'SET_MODULE9_INITIALSTATE',
              payload: module,
            });
          }
          if (module.name === 'Close') {
            config = ModulesService.getModuleConfig({
              currentModule: module,
              previousModule: modules.find(
                (module) => module.name === 'Respond'
              ),
              totalDays: 9,
              bgImage:
                '/Module10Images/Day+Scene+Nav+Template+-+ML+%E2%80%93+6.png',
              destiny: '/close/navigation',
              title: module.name,
              character: 'Bird',
              welcomeVideo: '491edf3c8360f799837f06ce3fd2/480.m3u8',
              login,
            });
            dispatch({
              type: 'SET_MODULE10_INITIALSTATE',
              payload: module,
            });
          }

          return {
            ...module,
            ...config,
          };
        });
      setModulesConfig(mappedModules);
    },
    [dispatch, login]
  );

  const getStudentModules = useCallback(async () => {
    const data = await ModulesService.getStudentModules(login.endPoint);
    getModulesConfiguration(data.modules);
  }, [getModulesConfiguration]);

  useEffect(() => {
    getStudentModules();
  }, [getStudentModules]);

  return (
    <ModulesDashboard
      modules={modulesConfig}
      pageTitle='Verbal Communication Skills'
      worldMapImage={WorldMap}
      grade={login.grade}
      unit={2}
    />
  );
};
export default Unit2Navigation;
